"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFormikCheckboxList = exports.StyledFormikCheckbox = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const main_1 = require("../../components/checkbox/main");
const list_1 = require("../../components/checkbox/list");
const variants_1 = require("../../themes/variants");
exports.StyledFormikCheckbox = (0, styled_components_1.default)(main_1.Checkbox).withConfig({
    shouldForwardProp: (prop) => !["status", "validate"].includes(prop),
}) `
  ${({ status, theme }) => {
    if (status) {
        const color = `${status === "error"
            ? (0, variants_1.variantTextColor)({ theme, variant: "error" })
            : (0, variants_1.variantTextColor)({ theme, variant: "success" })}!important`;
        return (0, styled_components_1.css) `
        &[data-testid="checkbox"] {
          color: ${color};
        }
      `;
    }
}}
`;
exports.StyledFormikCheckboxList = (0, styled_components_1.default)(list_1.CheckboxList).withConfig({
    shouldForwardProp: (prop) => !["status"].includes(prop),
}) `
  ${({ status, theme }) => {
    if (status) {
        const color = `${status === "error"
            ? (0, variants_1.variantTextColor)({ theme, variant: "error" })
            : (0, variants_1.variantTextColor)({ theme, variant: "success" })}!important`;
        return (0, styled_components_1.css) `
        [data-testid="checkboxlist-option"] [data-testid="checkbox"] {
          color: ${color};
        }
      `;
    }
}}
`;
//# sourceMappingURL=styled.js.map